;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('FilterGroupsDropdownController', filterGroupsDropdownController)

  /* @ngInject */
  function filterGroupsDropdownController ($scope, $attrs, $timeout, GroupService, ToastService) {
    const defaultGroupsList = Array.from($scope.defaultGroupsList)

    $scope.groupsList = defaultGroupsList
    $scope.groupsSelected = []
    $scope.groupsSelectedCache = []

    $scope.groupInput = {
      search: ''
    }

    $scope.flags = {
      hasShowMoreButton: false,
      loadingShowMore: false,
      noResults: false,
      loading: false,
      skip: null,
      top: 4
    }

    const api = {
      _loadDataGroups,
      _successGetDataGroups,
      _errorGetDataGroups,
      _hasMoreResults,
      _initObserverShowMore,
      _verifyIntersectionButton,
      _getShowMore,
      _handleToggleDropdown,
      _mergeGroupsList,
      _checkGroupAlreadyExistsInArray,
      _checkEqualGroupId,
      _onShowDropdown,
      _onHideDropdown
    }
    this.getApi = () => api

    activate()

    function activate () {
      const dropdownParams = {
        action: 'nothing',
        direction: 'downward',
        fullTextSearch: true,
        onShow: api._onShowDropdown,
        onHide: api._onHideDropdown
      }

      api._handleToggleDropdown(dropdownParams)
    }

    $scope.$watch('params.groups', (newValue) => {
      $scope.groupsSelected = [...newValue]
      if (newValue.length && !$scope.groupInput.search) {
        api._mergeGroupsList($scope.groupsSelected, $scope.groupsList)
      } else {
        $scope.groupsList = defaultGroupsList
      }
    })

    $scope.handleSelect = (group) => {
      const indexNone = $scope.groupsSelected.findIndex(groupSelected => groupSelected.id === 'none')

      if (!group) {
        if (indexNone !== -1) {
          $scope.groupsSelected.splice(indexNone, 1)
        } else {
          $scope.groupsSelected = []
          $scope.groupsSelected.push({ id: 'none' })
        }

        return
      }

      const index = $scope.groupsSelected.findIndex(groupSelected => api._checkEqualGroupId(groupSelected, group))
      if (index !== -1) {
        $scope.groupsSelected.splice(index, 1)
      } else {
        if (indexNone !== -1) {
          $scope.groupsSelected.splice(indexNone, 1)
        }
        $scope.groupsSelected = [group, ...$scope.groupsSelected]
      }
    }

    $scope.isNoneSelected = function () {
      const hasNoneSelected = $scope.groupsSelected.find(groupSelected => groupSelected.id === 'none')

      return Boolean(hasNoneSelected)
    }

    $scope.isSelected = (group) => {
      const hasGroupSelected = $scope.groupsSelected.find(groupSelected => api._checkEqualGroupId(groupSelected, group))

      return Boolean(hasGroupSelected)
    }

    $scope.handleRemove = (removeJustSelected) => {
      if (removeJustSelected) {
        $scope.groupsSelectedCache = [...$scope.groupsSelected]
        $scope.groupsSelected = []
        return
      }

      $scope.params.groups = []
      api._handleToggleDropdown('hide')
    }

    $scope.handleApply = () => {
      if ($scope.groupsSelected.length) {
        $scope.params.groups = $scope.groupsSelected
      } else {
        $scope.params.groups = []
      }

      api._handleToggleDropdown('hide')
      $scope.groupsList = defaultGroupsList
      $scope.groupInput.search = ''
      $scope.flags.skip = null
    }

    $scope.groupSearchInput = () => {
      $scope.flags.loading = true
      $scope.flags.skip = null
      api._loadDataGroups($scope.groupInput.search)
    }

    $scope.scrollShowMore = api._getShowMore

    /**
     *  @param {object} search - Object with search input
     *  @param {boolean} loadMore - if true, load more groups
     *  @description - Load groups from API
     */
    function _loadDataGroups (search, loadMore) {
      GroupService.getGroups($scope.flags.top, $scope.flags.skip, search).then(response => {
        api._successGetDataGroups(response, loadMore)
      })
        .catch(api._errorGetDataGroups)
    }

    /**
     *  @param {object} response - response from server
     *  @param {boolean} loadMore - if true, merge groupsList with response.data
     *  @description - Success callback for getGroups
     */
    function _successGetDataGroups (response, loadMore) {
      $scope.flags.noResults = false

      const { results, __count } = response.d

      if (loadMore) {
        api._mergeGroupsList($scope.groupsList, results)
      } else {
        $scope.groupsList = results
      }

      $timeout(api._initObserverShowMore, 500, false)

      $scope.flags.hasShowMoreButton = api._hasMoreResults(__count, $scope.groupsList.length)

      if (!$scope.groupsList.length) {
        $scope.flags.loading = false
        $scope.flags.noResults = true
        return
      }

      $scope.flags.loadingShowMore = false
      $scope.flags.loading = false
    }

    /**
     *  @description - Error callback for getGroups
     */
    function _errorGetDataGroups () {
      ToastService.defaultErrorToast()
      $scope.flags.loading = false
      $scope.flags.loadingShowMore = false
      $scope.flags.noResults = true
    }

    /**
     *  @param {Number} totalCount - total count of groups
     *  @param {Number} responseLength - total count of array of groups in response
     */
    function _hasMoreResults (totalCount, responseLength) {
      if (!responseLength) {
        return false
      }

      return totalCount > responseLength
    }

    /**
     *  @description Create the intersection observer by calling its constructor and passing
     *  it a callback function to be run whenever a threshold is crossed in one direction
     *  or the other
     */
    function _initObserverShowMore () {
      const showMoreButton = $attrs.$$element.find('.button-load-more')

      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.4
      }

      const observer = new IntersectionObserver(api._verifyIntersectionButton, options)

      if (showMoreButton[0]) {
        observer.observe(showMoreButton[0])
      }
    }

    /**
     *  @param {object} entry - one entry for each target which reported a change in its intersection status.
     *  @description this method verify if button is show, if is show, call method to load more groups
     */
    function _verifyIntersectionButton ([entry]) {
      if (entry.isIntersecting && entry.intersectionRatio >= 0.4 && entry.intersectionRatio < 1 && $scope.flags.hasShowMoreButton) {
        $timeout(api._getShowMore, 0, true)
      }
    }

    /**
     *  @description this method get the next page of groups
     */
    function _getShowMore () {
      $scope.flags.loadingShowMore = true
      $scope.flags.skip = $scope.flags.top + $scope.flags.skip
      api._loadDataGroups($scope.groupInput.search, true)
    }

    /**
     *  @param {object | string} options - config options for semantic dropdown
     *  @description this method open/close the dropdown menu, or initialize it
     */
    function _handleToggleDropdown (options) {
      $timeout(() => {
        $attrs.$$element.find('.ui.dropdown.filter-groups-dropdown').dropdown(options)
      }, 100, false)
    }

    /**
     *  @typedef {Array} ArrayList
     *  @param {ArrayList} firstArray - items that will be first in the new array of groups
     *  @param {ArrayList} lastArray - items that will be last in the new array of groups
     *  @description this method merge two arrays and create a new array, only serve to merge the array of groups
     */
    function _mergeGroupsList (firstArray, lastArray) {
      const updatedList = lastArray.map(api._checkGroupAlreadyExistsInArray).filter(Boolean)
      $scope.groupsList = [...firstArray, ...updatedList]
    }

    /**
     *  @param {object} group - object of group
     *  @description this method check if the group already exists in the array of groups
     */
    function _checkGroupAlreadyExistsInArray (group) {
      const index = $scope.groupsSelected.findIndex(selectedGroup => api._checkEqualGroupId(selectedGroup, group))
      if (index === -1) {
        return group
      }
    }

    /**
     *  @param {object} selectedGroup - object of group
     *  @param {object} group - object of selectedGroup
     *  @description this method checks if the selectedGroup is equal to the group
     */
    function _checkEqualGroupId (selectedGroup, group) {
      return selectedGroup.id === group.id
    }

    /**
     *  @description this method is called on show the semantic dropdown
     */
    function _onShowDropdown () {
      $timeout(api._initObserverShowMore, 500, false)

      $timeout(() => {
        $scope.flags.hasShowMoreButton = api._hasMoreResults($scope.countGroups, $scope.groupsList.length)
      }, 0, true)
    }

    /**
     *  @description this method is called on hide the semantic dropdown
     */
    function _onHideDropdown () {
      if (!$scope.groupsSelected.length && $scope.groupsSelectedCache.length) {
        $scope.groupsSelected = [...$scope.groupsSelectedCache]
      }
    }
  }
})()
